<template>
  <div
    :data-direction="scrollDirection"
    :class="[
      'flex flex-col',
      'w-full',
      'z-999',
      // 判断是否主页区分定位方式
      isHomePage ? 'fixed' : 'sticky',
      'top-0',
      // 用伪元素作为背景以控制动画
      'before:duration-500',
      'before:w-full before:h-0 before:bg-default',
      'before:absolute before:top-0 before:left-0 before:-z-1',
      // 位于首页以外的页面时
      !isHomePage && 'before:h-full shadow-sm',
      // 位于首页且滚动条处于顶部时
      isHomePage && isOnTop
        ? '[&_button]:text-white'
        : 'before:h-full [&_button]:text-muted shadow-sm',
      // 根据页面滚动方向控制顶栏y轴收缩
      'transition-all duration-500',
      storageConfigUI.navAutoHide &&
        'data-[direction=-1]:translate-y-0 data-[direction=1]:-translate-y-full',
    ]"
  >
    <!-- 条形加载进度条 -->
    <!-- <NuxtLoadingIndicator
        :height="6"
        color="repeating-linear-gradient(to right,#fff 0%,#f68f1e 100%)"
      /> -->
    <!-- 渐变条 -->
    <div :class="['h-(--gradient-line-height) w-full', 'bg_linear_to_r']" />

    <!-- 顶栏本体 -->
    <UHeader
      :toggle="{
        size: 'xl',
        color: 'primary',
        //   variant: 'ghost',
        //   class: 'rounded-full',
      }"
      :ui="{
        root: [
          // 在父容器以伪元素控制背景色
          'bg-transparent',
          '[&_button]:hover:text-primary',
        ],
        // 抽屉未打开时候的顶栏容器
        container: '',
        // 抽屉打开时候的顶栏容器
        header: '',
        // 侧边栏主内容容器
        body: 'p-0 sm:p-0',
        // 左中右容器
        left: 'relative',
        // center: '',
        right: 'gap-0',
      }"
    >
      <template #left>
        <!-- LOGO容器 -->
        <Motion
          :initial="{ opacity: 0, x: 120 }"
          :while-in-view="{ opacity: 1, x: 0 }"
          :transition="{
            type: 'spring',
            stiffness: 20,
            damping: 20,
          }"
          :in-view-options="{
            once: true,
          }"
          class="flex justify-start items-center cursor-pointer"
        >
          <NuxtImg
            :src="configSite.LOGO"
            draggable="false"
            alt="Crystal Network Logo"
            width="120"
            @click="useLocalePush('/')"
          />
        </Motion>
      </template>

      <!-- 中间插槽 -->
      <template #default>
        <!-- 下拉菜单组 -->
        <UNavigationMenu :items="appMenu" orientation="horizontal" content-orientation="vertical" />
      </template>

      <!-- 右侧插槽 -->
      <template #right>
        <div :class="['flex lg:gap-2 gap-0']">
          <!-- 搜索功能 -->
          <CommonDialogContentSearch />
          <!-- 联系我们按钮 -->
          <UButton
            icon="ri:customer-service-line"
            variant="ghost"
            size="xl"
            @click="useLocalePush('/about/contact')"
          />

          <!-- 语言切换按钮 -->
          <UDropdownMenu
            :items="localeMap"
            :modal="false"
            :content="{
              align: 'center',
              side: 'bottom',
              sideOffset: 0,
            }"
          >
            <UButton :icon="i18nLableConfig[locale].icon" variant="ghost" size="xl" />
          </UDropdownMenu>
        </div>
      </template>

      <!-- 侧边栏 -->
      <template #body>
        <UNavigationMenu
          :items="appMenu"
          highlight
          highlight-color="primary"
          orientation="vertical"
          :popover="true"
          content-orientation="vertical"
        />
      </template>
    </UHeader>
  </div>
</template>

<script setup lang="ts">
  import type { DropdownMenuItem } from '@nuxt/ui'

  const { storageConfigUI } = useAppStorage()
  const { locale, locales, setLocale } = useI18n()
  const { y } = useWindowScroll()
  const isHomePage = useIsHomePage()
  const { configSite } = useConfigStatic()

  /** 导航栏菜单数据 */
  const { appMenu } = useConfigMenu()

  // 根据y轴滚动位置和路由动态变换header样式(px阈值)
  const isOnTop = computed(() => y.value < configSite.SHOW_BG_THRESHOLD)

  /** 当前页面滚动方向，1是向下，-1是向上 */
  const scrollDirection = ref<number>(-1)

  /** 将nuxt.config.ts文件定义的i18n数据转换为用于组件展示的数据对象 */
  const localeMap = computed<DropdownMenuItem[][]>(() => {
    return [
      locales.value
        .filter(i => i.code !== locale.value)
        .map(curLocale => ({
          label: i18nLableConfig[curLocale.code].label,
          icon: i18nLableConfig[curLocale.code].icon,
          onSelect() {
            setLocale(curLocale.code)
          },
        })),
    ]
  })

  useLenis(instance => {
    const newDirection = instance.direction
    if (scrollDirection.value !== newDirection) {
      scrollDirection.value = newDirection
      // useDPrint(`滚动方向改变`, newDirection)
    }
  })
</script>
